import React, {useEffect, useState} from 'react'
import {useSearchParams} from 'react-router-dom'

import ContactPage from './AllContacts'
import ListPage from './List/ListData/List'
import UploadHistory from './UploadHistory/UploadHistory'
import SegmentList from './Segments/SegmentList'
import SubscribePage from './Subscribe'
import UnsubscribePage from './Unsubscribe'
import useNewNavigation from '../../../hooks/useNewNavigation'
import TagsList from './Tags/TagsList'

export const CONTACT_CATEGORIES = {
  CONTACTS: 'contacts',
  LISTS: 'lists',
  SEGMENTS: 'segments',
  TAGS: 'tags',
  SUPPRESSION: 'suppression',
  SUBSCRIBES: 'subscribes',
  UNSUBCRIBES: 'unsubcribes',
  HISTORY: 'history',
} as const

const ContactCategory = [
  {label: 'All Contacts', value: CONTACT_CATEGORIES.CONTACTS, disabled: false},
  {label: 'Lists', value: CONTACT_CATEGORIES.LISTS, disabled: false},
  {label: 'Segments', value: CONTACT_CATEGORIES.SEGMENTS, disabled: false},
  {label: 'Tags', value: CONTACT_CATEGORIES.TAGS, disabled: false},
  {label: 'Suppression', value: CONTACT_CATEGORIES.SUPPRESSION, disabled: true},
  {label: 'Subscribed', value: CONTACT_CATEGORIES.SUBSCRIBES, disabled: false},
  {label: 'Unsubscribed', value: CONTACT_CATEGORIES.UNSUBCRIBES, disabled: false},
  {label: 'History', value: CONTACT_CATEGORIES.HISTORY, disabled: false},
]

interface TotalState {
  contacts: number
  tasks: number
  lists: number
  segments: number
  tags: number
  subscribes: number
  unsubcribes: number
}

const DEFAULT_CATEGORY = CONTACT_CATEGORIES.CONTACTS

const NewContacts = () => {
  const {newNavigation} = useNewNavigation()
  const [searchParams, setSearchParams] = useSearchParams()
  const paramCategory = searchParams.get('category')

  const [category, setCategory] = useState<string>(paramCategory || DEFAULT_CATEGORY)

  const [total, setTotal] = useState<TotalState>({
    contacts: 0,
    tasks: 0,
    lists: 0,
    segments: 0,
    tags: 0,
    subscribes: 0,
    unsubcribes: 0,
  })

  const setTotalField = (key: keyof TotalState, value?: number) => {
    setTotal((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  useEffect(() => {
    const currentParams = new URLSearchParams(searchParams)
    currentParams.set('category', category)
    setSearchParams(currentParams, {replace: true})
  }, [category, setSearchParams, searchParams])

  return (
    <>
      <div className={`card`}>
        <div className='card-header border-0 pt-12 px-14'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2'>Contacts</span>
            <span className='text-muted fw-bold fs-7'>Here you can see all your contacts</span>
          </h3>
        </div>

        <div className='d-flex overflow-auto h-35px px-8 mt-8 justify-content-between border-bottom mb-2'>
          <ul
            className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-3 flex-nowrap'
            style={{fontWeight: 500}}
          >
            {ContactCategory.map((key: any, index: any) => {
              const isActive = key?.value === category
              const isDisabled = key?.disabled
              const count = total[key.value as keyof TotalState]

              return (
                <li
                  key={index?.toString()}
                  className='nav-item'
                  onClick={() => !isDisabled && setCategory(key?.value)}
                >
                  <div
                    className={`nav-link me-6 text-active-primary fs-3 ${
                      isActive ? 'active' : ''
                    } ${isDisabled ? 'pe-none text-muted opacity-50' : 'cursor-pointer'}`}
                  >
                    {key?.label} {count ? `(${count})` : ''}
                  </div>
                </li>
              )
            })}
          </ul>
        </div>

        {category === CONTACT_CATEGORIES.CONTACTS ? (
          <ContactPage
            newNavigation={!!newNavigation}
            setTotal={(value?: number) => setTotalField(CONTACT_CATEGORIES.CONTACTS, value)}
          />
        ) : null}
        {category === CONTACT_CATEGORIES.LISTS ? (
          <ListPage
            newNavigation={!!newNavigation}
            setTotal={(value?: number) => setTotalField(CONTACT_CATEGORIES.LISTS, value)}
          />
        ) : null}
        {category === CONTACT_CATEGORIES.TAGS ? (
          <TagsList
            newNavigation={!!newNavigation}
            setTotal={(value?: number) => setTotalField(CONTACT_CATEGORIES.TAGS, value)}
          />
        ) : null}
        {category === CONTACT_CATEGORIES.HISTORY ? (
          <UploadHistory newNavigation={!!newNavigation} />
        ) : null}
        {category === CONTACT_CATEGORIES.SEGMENTS ? (
          <SegmentList
            newNavigation={!!newNavigation}
            setTotal={(value?: number) => setTotalField(CONTACT_CATEGORIES.SEGMENTS, value)}
          />
        ) : null}
        {category === CONTACT_CATEGORIES.SUBSCRIBES ? (
          <SubscribePage
            newNavigation={!!newNavigation}
            setTotal={(value?: number) => setTotalField(CONTACT_CATEGORIES.SUBSCRIBES, value)}
          />
        ) : null}
        {category === CONTACT_CATEGORIES.UNSUBCRIBES ? (
          <UnsubscribePage
            newNavigation={!!newNavigation}
            setTotal={(value?: number) => setTotalField(CONTACT_CATEGORIES.UNSUBCRIBES, value)}
          />
        ) : null}
      </div>
    </>
  )
}

export default NewContacts
